<script setup>
import useDateUtils from "@/api/composable/date-utils";

const props = defineProps({
  appConfig: Object
})

const dataUtils = useDateUtils();
</script>

<template>
  <footer id="footer" class="footer-texts-more-lighten">
    <div class="container">
      <div class="row py-4 my-5">
        <div class="col-md-6 col-lg-4 mb-5 mb-lg-0">
          <h5 class="text-4 text-color-light mb-3">สอบถามข้อมูลเพิ่มเติม</h5>
          <ul class="list list-unstyled">
            <li class="pb-1 mb-2">
              <span class="d-block font-weight-normal line-height-1 text-color-light">{{ props?.appConfig?.contactOrg }}</span>
              {{ props.appConfig?.contactAddress }}
            </li>
            <li class="pb-1 mb-2">
              <span class="d-block font-weight-normal line-height-1 text-color-light">สายด่วน</span>
              <a :href="`tel:${props.appConfig?.hotline}`">{{  props.appConfig?.hotline }}</a>
            </li>
            <li class="pb-1 mb-2">
              <span class="d-block font-weight-normal line-height-1 text-color-light">อีเมล</span>
              <a :href="`mailto:${props.appConfig?.mail}`">{{ props.appConfig?.mail }}</a>
            </li>
            <li class="pb-1 mb-2">
              <span class="d-block font-weight-normal line-height-1 text-color-light">เวลาทำการ</span>
              {{ props.appConfig?.workingDate }}
            </li>
          </ul>
        </div>
        <div class="col-md-6 col-lg-6 mb-5 mb-md-0">
          <h5 class="text-4 text-color-light mb-3">เงื่อนไขและนโยบายที่เกี่ยวข้อง</h5>
          <article class="mb-3">
            <a :href="props.appConfig?.dataProtectionLink" class="text-color-light text-3-5" target="_blank">{{ props.appConfig?.dataProtectionTitle }}</a>
            <p class="line-height-2 mb-0">ปรับปรุงเมื่อ {{ dataUtils.toDateThai(props.appConfig?.dataProtectionUpdateDate)}}</p>
          </article>
          <article class="mb-3">
            <a :href="props.appConfig?.privacyPolicyLink" class="text-color-light text-3-5" target="_blank">{{ props.appConfig?.privacyPolicyTitle }}</a>
            <p class="line-height-2 mb-0">ปรับปรุงเมื่อ {{ dataUtils.toDateThai(props.appConfig?.privacyPolicyUpdateDate)}}</p>
          </article>
          <article>
            <a :href="props.appConfig?.termsOfUseLink" class="text-color-light text-3-5" target="_blank">{{ props.appConfig?.termsOfUseTitle }}</a>
            <p class="line-height-2 mb-0">ปรับปรุงเมื่อ {{ dataUtils.toDateThai(props.appConfig?.termsOfUseUpdateDate)}}</p>
          </article>
        </div>
        <div class="col-md-6 col-lg-2 mb-5 mb-lg-0">
          <h5 class="text-4 text-color-light mb-3">USEFUL LINKS</h5>
          <ul class="list list-unstyled mb-0">
            <li class="mb-0"><a :href="'/'">ข้อมูลเปิด</a></li>
            <li class="mb-0"><a :href="'/manual'">คำแนะนำการใช้งาน</a></li>
            <li class="mb-0"><a :href="'/faq'">คำถามที่พบบ่อย</a></li>
            <li class="mb-0"><a href="#">ติดต่อเรา</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="footer-copyright footer-copyright-style-2 pt-4 pb-5">
        <div class="row">
          <div class="col-8">
            <p class="mb-0"><strong>DBD</strong> - © สงวนลิขสิทธิ์ 2566 กรมพัฒนาธุรกิจการค้า</p>
          </div>
          <div class="col-4 text-end">
            <p class="mb-0">Version {{ props.appConfig?.version }} | <span class="badge badge-md" :class="props.appConfig?.env === 'PROD' ? 'badge-success' : 'badge-danger'">{{ props.appConfig?.env }}</span></p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>

</style>
